import React, {useState} from 'react';
import {Col, CustomInput, Input, Label} from "reactstrap";

const Filter = (props) => {
    const Items = props.items
    const [filter, setFilter] = useState(props.Filters )
    const setFilters = (e) => {
        const data = filter
        if (e.target.value !== "all") {
            data[e.target.name] = e.target.value
        } else {
            delete data[e.target.name];

        }
        setFilter(data)
        props.onSetFilters(data)
    }

    return (
        <>
            {
                Items && Items.map(item => {
                    return (
                        <Col sm={4} className={'text-right mb-3'} key={item.id}>
                            <Label for={item.id}>{item.title}</Label>
                            <CustomInput  type="select" name={item.id} id={item.id} value={filter[item.id]} onChange={setFilters}>
                                <option value={"all"}>همه</option>
                                {item.values.sort((a,b) => (a.title < b.title) ? -1 : 1).map(value => (
                                    <option value={value.value} key={value.value}>{value.title}</option>
                                ))}
                            </CustomInput >
                        </Col>
                    )
                })
            }

        </>
    );
};

export default Filter;